angular.module('SpidApp').directive('piggyBank',
    ['MoneyTransferService','BASE_PUBLIC_URL','AgencyService',
        function (MoneyTransferService,BASE_PUBLIC_URL,AgencyService) {
            return {
                restrict: 'E',
                templateUrl : BASE_PUBLIC_URL + '/views/partials/piggy-bank.html',
                scope : {
                    currentAmount : '=',
                    agencyId : '='
                },
                link: function ($scope) {
                    $scope.readyToDisplay = false;

                    var loadCurrentAmount = function (agencyId) {
                        AgencyService.find(agencyId).then(function (agency) {
                            $scope.agency = agency;
                            MoneyTransferService.findByAgencyId(agencyId).then(function (listeMoneyTransfer) {
                                var lastElemListeMoneyTransfer = _.chain(listeMoneyTransfer)
                                    .sortBy('updated_at')
                                    .last()
                                    .value();

                                if (lastElemListeMoneyTransfer !== null && _.size(lastElemListeMoneyTransfer) > 0) {
                                    $scope.currentAmount = lastElemListeMoneyTransfer.current.toFixed(2);
                                } else {
                                    $scope.currentAmount = 0;
                                }
                                $scope.readyToDisplay = true;
                            })
                        });
                    };

                    $scope.$watch('agencyId', function(newValue) {
                        if(typeof newValue === "undefined"){
                            return;
                        }
                        loadCurrentAmount(newValue);
                    });

                }
            }
        }
    ]
);
